;(function(win, ko, $, undefined) {
    
    if(parseFloat($.fn.jquery) >= 3){
        $.fn.size = function() {return (this && this.length) || 0}
    }

    if (!win.app) win.app = {}

    ;(function() {
        const unified = win.console || {};
        const dummy = {};
        _.each([
                "assert", "clear", "count", "debug", "dir", "dirxml", "error",
                "group", "groupCollapsed", "groupEnd", "info", "log", "time", "timeEnd",
                "trace", "warn", "table"
            ],
            function(m) {
                if (!unified[m]) unified[m] = _.noop;
                dummy[m] = _.noop
            });

        win.app.enableConsole = function() {
            win.app.consoleEnabled = true;
            win.app.console = unified
        };
        win.app.disableConsole = function() {
            win.app.consoleEnabled = false;
            win.app.console = dummy
        };
        win.app.enableConsole()
    })();

    /**
     * Define win app.utils functions
     */
    win.app.utils = {
        ajaxResult: function() {
            if (!window['OmniFaces'] || !OmniFaces.Ajax) return undefined;
            return OmniFaces.Ajax.data
        },

        stringEndsWith: function(s, suffix) {
            s = s + "";
            return s.indexOf(suffix, s.length - suffix.length) !== -1
        },

        trimString: function(s) {
            s = s.replace(/^\s+/, "");
            for (let i = s.length - 1; i >= 0; i--) {
                if (/\S/.test(s.charAt(i))) {
                    s = s.substring(0, i + 1);
                    break
                }
            }
            return s
        },

        isFutureDate : function (day) {
            const date = new Date();
            date.setDate(date.getDate() - 1);
            return day.date.getTime() - date.getTime() >= 0;

        },

        idToSelector : function(id) {
            return id.replace(/:/g, "\\:");
        },

        setSelection : function(field, start, end) {
            const el = $(field).get(0);
            el.focus();
            if (el.setSelectionRange) {
                el.setSelectionRange(start, end);
            } else if (el.createTextRange) {
                const range = el.createTextRange();
                range.collapse(true);
                range.moveEnd('character', end);
                range.moveStart('character', start);
                range.select();
            }
        },

        sequence: (function() {
            let _id = 0;
            return {
                next: function() {
                    _id = _id + 1;
                    return _id
                },
                peek: function() {
                    return _id
                }
            }
        })(),

        getIfromeWindow: function(iframe) {
            let $frame = $(iframe);
            if ($frame.length === 0) return undefined;
            let el = $frame[0];
            return el.contentWindow ? el.contentWindow : el.contentDocument.defaultView;
        },

        pluralize: (function () {
            // Rule storage - pluralize and singularize need to be run sequentially,
            // while other rules can be optimized using an object for instant lookups.
            let pluralRules = [];
            let singularRules = [];
            let uncountables = {};
            let irregularPlurals = {};
            let irregularSingles = {};

            /**
             * Title case a string.
             *
             * @param  {string} str
             * @return {string}
             */
            function toTitleCase (str) {
                return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
            }

            /**
             * Sanitize a pluralization rule to a usable regular expression.
             *
             * @param  {(RegExp|string)} rule
             * @return {RegExp}
             */
            function sanitizeRule (rule) {
                if (typeof rule === 'string') {
                    return new RegExp('^' + rule + '$', 'i');
                }

                return rule;
            }

            /**
             * Pass in a word token to produce a function that can replicate the case on
             * another word.
             *
             * @param  {string}   word
             * @param  {string}   token
             * @return {Function}
             */
            function restoreCase (word, token) {
                // Tokens are an exact match.
                if (word === token) {
                    return token;
                }

                // Upper cased words. E.g. "HELLO".
                if (word === word.toUpperCase()) {
                    return token.toUpperCase();
                }

                // Title cased words. E.g. "Title".
                if (word[0] === word[0].toUpperCase()) {
                    return toTitleCase(token);
                }

                // Lower cased words. E.g. "test".
                return token.toLowerCase();
            }

            /**
             * Interpolate a regexp string.
             *
             * @param  {string} str
             * @param  {Array}  args
             * @return {string}
             */
            function interpolate (str, args) {
                return str.replace(/\$(\d{1,2})/g, function (match, index) {
                    return args[index] || '';
                });
            }

            /**
             * Sanitize a word by passing in the word and sanitization rules.
             *
             * @param  {string}   token
             * @param  {string}   word
             * @param  {Array}    collection
             * @return {string}
             */
            function sanitizeWord (token, word, collection) {
                // Empty string or doesn't need fixing.
                if (!token.length || uncountables.hasOwnProperty(token)) {
                    return word;
                }

                let len = collection.length;

                // Iterate over the sanitization rules and use the first one to match.
                while (len--) {
                    let rule = collection[len];

                    // If the rule passes, return the replacement.
                    if (rule[0].test(word)) {
                        return word.replace(rule[0], function (match, index, word) {
                            let result = interpolate(rule[1], arguments);

                            if (match === '') {
                                return restoreCase(word[index - 1], result);
                            }

                            return restoreCase(match, result);
                        });
                    }
                }

                return word;
            }

            /**
             * Replace a word with the updated word.
             *
             * @param  {Object}   replaceMap
             * @param  {Object}   keepMap
             * @param  {Array}    rules
             * @return {Function}
             */
            function replaceWord (replaceMap, keepMap, rules) {
                return function (word) {
                    // Get the correct token and case restoration functions.
                    const token = word.toLowerCase();

                    // Check against the keep object map.
                    if (keepMap.hasOwnProperty(token)) {
                        return restoreCase(word, token);
                    }

                    // Check against the replacement map for a direct word replacement.
                    if (replaceMap.hasOwnProperty(token)) {
                        return restoreCase(word, replaceMap[token]);
                    }

                    // Run all the rules against the word.
                    return sanitizeWord(token, word, rules);
                };
            }

            /**
             * Pluralize or singularize a word based on the passed in count.
             *
             * @param  {string}  word
             * @param  {number}  count
             * @param  {boolean} inclusive
             * @return {string}
             */
            function pluralize (word, count, inclusive) {
                const pluralized = count === 1
                    ? pluralize.singular(word) : pluralize.plural(word);

                return (inclusive ? count + ' ' : '') + pluralized;
            }

            /**
             * Pluralize a word.
             *
             * @type {Function}
             */
            pluralize.plural = replaceWord(
                irregularSingles, irregularPlurals, pluralRules
            );

            /**
             * Singularize a word.
             *
             * @type {Function}
             */
            pluralize.singular = replaceWord(
                irregularPlurals, irregularSingles, singularRules
            );

            /**
             * Add a pluralization rule to the collection.
             *
             * @param {(string|RegExp)} rule
             * @param {string}          replacement
             */
            pluralize.addPluralRule = function (rule, replacement) {
                pluralRules.push([sanitizeRule(rule), replacement]);
            };

            /**
             * Add a singularization rule to the collection.
             *
             * @param {(string|RegExp)} rule
             * @param {string}          replacement
             */
            pluralize.addSingularRule = function (rule, replacement) {
                singularRules.push([sanitizeRule(rule), replacement]);
            };

            /**
             * Add an uncountable word rule.
             *
             * @param {(string|RegExp)} word
             */
            pluralize.addUncountableRule = function (word) {
                if (typeof word === 'string') {
                    uncountables[word.toLowerCase()] = true;
                    return;
                }

                // Set singular and plural references for the word.
                pluralize.addPluralRule(word, '$0');
                pluralize.addSingularRule(word, '$0');
            };

            /**
             * Add an irregular word definition.
             *
             * @param {string} single
             * @param {string} plural
             */
            pluralize.addIrregularRule = function (single, plural) {
                plural = plural.toLowerCase();
                single = single.toLowerCase();

                irregularSingles[single] = plural;
                irregularPlurals[plural] = single;
            };

            /**
             * Irregular rules.
             */
            [
                // Pronouns.
                ['I', 'we'],
                ['me', 'us'],
                ['he', 'they'],
                ['she', 'they'],
                ['them', 'them'],
                ['myself', 'ourselves'],
                ['yourself', 'yourselves'],
                ['itself', 'themselves'],
                ['herself', 'themselves'],
                ['himself', 'themselves'],
                ['themself', 'themselves'],
                ['is', 'are'],
                ['was', 'were'],
                ['has', 'have'],
                ['this', 'these'],
                ['that', 'those'],
                // Words ending in with a consonant and `o`.
                ['echo', 'echoes'],
                ['dingo', 'dingoes'],
                ['volcano', 'volcanoes'],
                ['tornado', 'tornadoes'],
                ['torpedo', 'torpedoes'],
                // Ends with `us`.
                ['genus', 'genera'],
                ['viscus', 'viscera'],
                // Ends with `ma`.
                ['stigma', 'stigmata'],
                ['stoma', 'stomata'],
                ['dogma', 'dogmata'],
                ['lemma', 'lemmata'],
                ['schema', 'schemata'],
                ['anathema', 'anathemata'],
                // Other irregular rules.
                ['ox', 'oxen'],
                ['axe', 'axes'],
                ['die', 'dice'],
                ['yes', 'yeses'],
                ['foot', 'feet'],
                ['eave', 'eaves'],
                ['goose', 'geese'],
                ['tooth', 'teeth'],
                ['quiz', 'quizzes'],
                ['human', 'humans'],
                ['proof', 'proofs'],
                ['carve', 'carves'],
                ['valve', 'valves'],
                ['looey', 'looies'],
                ['thief', 'thieves'],
                ['groove', 'grooves'],
                ['pickaxe', 'pickaxes'],
                ['whiskey', 'whiskies']
            ].forEach(function (rule) {
                return pluralize.addIrregularRule(rule[0], rule[1]);
            });

            /**
             * Pluralization rules.
             */
            [
                [/s?$/i, 's'],
                [/[^\u0000-\u007F]$/i, '$0'],
                [/([^aeiou]ese)$/i, '$1'],
                [/(ax|test)is$/i, '$1es'],
                [/(alias|[^aou]us|tlas|gas|ris)$/i, '$1es'],
                [/(e[mn]u)s?$/i, '$1s'],
                [/([^l]ias|[aeiou]las|[emjzr]as|[iu]am)$/i, '$1'],
                [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'],
                [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'],
                [/(seraph|cherub)(?:im)?$/i, '$1im'],
                [/(her|at|gr)o$/i, '$1oes'],
                [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'],
                [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'],
                [/sis$/i, 'ses'],
                [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'],
                [/([^aeiouy]|qu)y$/i, '$1ies'],
                [/([^ch][ieo][ln])ey$/i, '$1ies'],
                [/(x|ch|ss|sh|zz)$/i, '$1es'],
                [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'],
                [/([ml])(?:ice|ouse)$/i, '$1ice'],
                [/(pe)(?:rson|ople)$/i, '$1ople'],
                [/(child)(?:ren)?$/i, '$1ren'],
                [/eaux$/i, '$0'],
                [/m[ae]n$/i, 'men'],
                ['thou', 'you']
            ].forEach(function (rule) {
                return pluralize.addPluralRule(rule[0], rule[1]);
            });

            /**
             * Singularization rules.
             */
            [
                [/s$/i, ''],
                [/(ss)$/i, '$1'],
                [/((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)(?:sis|ses)$/i, '$1sis'],
                [/(^analy)(?:sis|ses)$/i, '$1sis'],
                [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'],
                [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'],
                [/ies$/i, 'y'],
                [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, '$1ie'],
                [/\b(mon|smil)ies$/i, '$1ey'],
                [/([ml])ice$/i, '$1ouse'],
                [/(seraph|cherub)im$/i, '$1'],
                [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|tlas|gas|(?:her|at|gr)o|ris)(?:es)?$/i, '$1'],
                [/(e[mn]u)s?$/i, '$1'],
                [/(movie|twelve)s$/i, '$1'],
                [/(cris|test|diagnos)(?:is|es)$/i, '$1is'],
                [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'],
                [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'],
                [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'],
                [/(alumn|alg|vertebr)ae$/i, '$1a'],
                [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'],
                [/(matr|append)ices$/i, '$1ix'],
                [/(pe)(rson|ople)$/i, '$1rson'],
                [/(child)ren$/i, '$1'],
                [/(eau)x?$/i, '$1'],
                [/men$/i, 'man']
            ].forEach(function (rule) {
                return pluralize.addSingularRule(rule[0], rule[1]);
            });

            /**
             * Uncountable rules.
             */
            [
                // Singular words with no plurals.
                'advice',
                'adulthood',
                'agenda',
                'aid',
                'alcohol',
                'ammo',
                'athletics',
                'bison',
                'blood',
                'bream',
                'buffalo',
                'butter',
                'carp',
                'cash',
                'chassis',
                'chess',
                'clothing',
                'commerce',
                'cod',
                'cooperation',
                'corps',
                'digestion',
                'debris',
                'diabetes',
                'energy',
                'equipment',
                'elk',
                'excretion',
                'expertise',
                'flounder',
                'fun',
                'gallows',
                'garbage',
                'graffiti',
                'headquarters',
                'health',
                'herpes',
                'highjinks',
                'homework',
                'housework',
                'information',
                'jeans',
                'justice',
                'kudos',
                'labour',
                'literature',
                'machinery',
                'mackerel',
                'mail',
                'media',
                'mews',
                'moose',
                'music',
                'news',
                'pike',
                'plankton',
                'pliers',
                'pollution',
                'premises',
                'rain',
                'research',
                'rice',
                'salmon',
                'scissors',
                'series',
                'sewage',
                'shambles',
                'shrimp',
                'species',
                'staff',
                'swine',
                'trout',
                'traffic',
                'transporation',
                'tuna',
                'wealth',
                'welfare',
                'whiting',
                'wildebeest',
                'wildlife',
                'you',
                // Regexes.
                /pox$/i, // "chickpox", "smallpox"
                /ois$/i,
                /deer$/i, // "deer", "reindeer"
                /fish$/i, // "fish", "blowfish", "angelfish"
                /sheep$/i,
                /measles$/i,
                /[^aeiou]ese$/i // "chinese", "japanese"
            ].forEach(pluralize.addUncountableRule);

            return pluralize;
        })(),

        preprocessVue: function(rootElement) {
            function bindExpression (el, expression) {
                let firstEqualPos = expression.indexOf("=");
                if (firstEqualPos === -1) {
                    $(el).attr(expression, '');
                } else {
                    $(el).attr(expression.substring(0, firstEqualPos), expression.substring(firstEqualPos + 1))
                }
            }
            function attachBulkBinding(el, expression) {
                const regex = new RegExp(/\(\((.*?)\)\)/g);
                let match;
                while ((match = regex.exec(expression)) !== null) {
                    bindExpression(this, match[1]);
                }
            }
            $.each($(rootElement).find("[vue-bulkbind]"), function() {
                attachBulkBinding(this, $(this).attr('vue-bulkbind'));
            });
            $.each($(rootElement).find("[vue-bind-children]"), function() {
                let element = this;
                $.each(element.attributes, function() {
                    try {
                        let attr = this, name, value, parts;
                        if (attr.specified) {
                            name = attr.name;
                            if (name.match(/^data-bind-child(?:-\d+)?$/i)) {
                                value = attr.value;
                                parts = value.split(/\s*@\s*/);
                                if (parts.length === 2) {
                                    $(element).find(parts[1]).each(function() {
                                        const expression = parts[0];
                                        if (expression[0] === '(' && expression[1] === '(') {
                                            attachBulkBinding(this, expression);
                                        } else {
                                            bindExpression(this, expression);
                                        }
                                    })
                                } else {
                                    app.console.error("Invalid v-bind-child content: " + value)
                                }
                            }
                        }
                    } catch (err) {
                        app.console.error(err)
                    }
                })
            })
        }
    }

    ;(function() {
        function intervalBind(vm, elem) {
            if (vm.__type__ === 'vue') {
                app.utils.preprocessVue(elem);
                if (!vm.__vue__) vm.__vue__ = [];
                let opts = $.extend({}, vm.vueOptions || {}, {
                    el: elem,
                    data: vm.data,
                    computed: vm.computed,
                    watch: vm.watch,
                    methods: vm.methods
                });
                vm.__vue__.push(new Vue(opts))
            } else {
                ko.applyBindings(vm, elem);
            }

            function isElementInDom(e) {
                if (document.contains) return document.contains(e);
                if (document.body.contains) return document.body.contains(e);
                while (elem && ko.utils.tagNameLower(elem) !== "html") elem = elem.parent;
                return !!elem
            }

            //clean up bound element list
            let parts = _.partition(vm.__elements__, isElementInDom);
            vm.__elements__ = parts[0];
            //clean up orphan elements
            if (vm.__type__ !== 'vue') {
                _.each(parts[1], function(e) {
                    ko.cleanNode(e)
                });
            }

            //clean up vue model
            if (vm.__type__ === 'vue') {
                let vueArrayParts = _.partition(vm.__vue__, (vm) => isElementInDom(vm.$el));
                vm.__vue__ = vueArrayParts[0];
                vm.m = vm.__vue__[0];
                _.each(vueArrayParts[1], (e) => e.$destroy());
            }

            //record bound element
            vm.__elements__.push(elem);

            //invoke __init__ callback
            try {
                if (vm.__init__) vm.__init__(elem)
            } catch (e) {
                win.app.console.error(e)
            }
        }

        function bind(elem) {
            const selector = elem;
            elem = $(elem);
            const vm = this;
            if (elem.size() > 0) {
                elem.each(function(idx, el) {
                    const vmName = $(this).attr("data-vm");
                    if (vmName === vm.__vmName__) {
                        if (_.indexOf(vm.__elements__, el) < 0) {
                            intervalBind(vm, el)
                        } else {
                            win.app.console.error("Element has already been bound to the same VM.");
                            win.app.console.error(element)
                        }
                    } else {
                        win.app.console.error("Element must have data-vm attribute refer to " + vm.__vmName__);
                        win.app.console.error(this)
                    }
                })
            } else {
                win.app.console.error("Element " + selector + " not found")
            }
        }

        function addVM(vmName, vm) {
            /* Clean up exiting vm */
            if (win.app.vm[vmName]) {
                const oldVM = win.app.vm[vmName];
                if (oldVM.__type__ === 'vue') {
                    if (oldVM.__vue__) {
                        _.each(oldVM.__vue__, function(v) {
                            try {
                                if (v.__destroy__) v.__destroy__();
                            } catch (e) {
                                app.console.error("Failed calling __destroy__ in " + oldVM.__vmName__);
                                app.console.error(e);
                            }
                            v.$destroy();
                        });
                    }
                } else {
                    try {
                        if (oldVM.__destroy__) oldVM.__destroy__();
                    } catch (e) {
                        app.console.error("Failed calling __destroy__ in " + oldVM.__vmName__);
                        app.console.error(e);
                    }
                    _.each(oldVM.__elements__, function(el) {
                        ko.cleanNode(el)
                    });
                }
                for (let p in oldVM) {
                    try {
                        if (oldVM.hasOwnProperty(p) && _.isFunction(oldVM[p]['dispose'])) {
                            oldVM[p].dispose.call(oldVM)
                        }
                    } catch(e) {}
                }
                oldVM.__elements__ = null;
                oldVM.__vue__ = null;
            }

            vm.__vmName__ = vmName;
            vm.__elements__ = [];
            win.app.vm[vmName] = vm;
        }

        function createVmOnConstructor(constructorName, vmNames) {
            if (!vmNames) vmNames = constructorName;
            if (!_.isArray(vmNames)) vmNames = [vmNames];
            _.each(vmNames, function(vmName) {win.app.createVM(constructorName, vmName)});
            return app.vm.constructor[constructorName];
        }

        _.extend(win.app,{
            constructors: {},
            vm: {},

            registerConstructor: function(name, type, func, isStatic) {
                if (_.isFunction(type)) {
                    isStatic = func;
                    func = type;
                    type = "ko"
                }
                if (isStatic && this.constructors[name]) return;

                func.prototype.bind = bind;
                func.prototype.__from__ = "Ctor-" + name;
                func.prototype.__type__ = type;

                const self = this;
                self.constructors[name] = function(vmName, options) {
                    if (_.isObject(vmName)) {
                        options = vmName;
                        vmName = undefined
                    }
                    if (!vmName) vmName = name;
                    const vm = new func(options);
                    addVM(vmName, vm);
                    return vm;
                };

                self.constructors[name].name = name;
                self.constructors[name].createVM = function(vmNames) {
                    return createVmOnConstructor(name, vmNames)
                };

                return self.constructors[name];
            },

            createVM: function() {
                let constructor, vmName, options, vm, self = this;
                /* Adjust arguments */
                if (_.isObject(arguments[0])) {
                    vm = arguments[0];
                    vmName = arguments[1]
                } else if (_.isString(arguments[1])) {
                    constructor = arguments[0];
                    vmName = arguments[1];
                    options = arguments[2]
                } else if (_.isObject(arguments[1])) {
                    vmName = constructor = arguments[0];
                    options = arguments[1]
                } else if (_.isUndefined(arguments[1])) {
                    if (_.isString(arguments[0])) {
                        vmName = constructor = arguments[0]
                    }
                }

                if (constructor) {  //Build from constructor
                    if (self.constructors[constructor]) {
                        vm = self.constructors[constructor](vmName, options)
                    } else {
                        self.console.error("Constructor " + constructor + " not defined.")
                    }
                } else if (vm) { //Build from JS model
                    //TODO VUE: adapt vue
                    if (_.isUndefined(vmName)) {
                        vmName = "vm_" + win.app.utils.id.next()
                    }
                    vm = ko.viewmodel.fromModel(vm);
                    vm.bind = bind;
                    vm.__from__ = "ko.viewmodel";
                    addVM(vmName, vm)
                } else {
                    self.console.error("Illegal arguments.");
                    return
                }
                return vm
            },

            updateVM: function(vmName, viewModel, addNewProperty) {
                const vm = _.isString(vmName) ? app.vm[vmName] : vmName;
                if (!vm) {
                    app.console.error("VM " + vmName + " not found!");
                    return;
                }
                //TODO VUE: adapt vue
                if (vm.__type__ === 'vue') return;

                function updatePropertyIfComplex(prop, value) {
                    if (ko.isWriteableObservable(prop)) {
                        prop(value)
                    }
                    else if (_.isArray(prop)) {
                        if (_.isArray(value)) updateArray(prop, value)

                    } else if (_.isObject(prop)) {
                        if (_.isObject(value)) updateObject(prop, value)
                    } else {
                        return false
                    }
                    return true
                }

                function updateObject(target, source) {
                    const pairs = _.pairs(source);
                    _.each(pairs, function(p) {
                        if (target.hasOwnProperty(p[0])) {
                            if (!updatePropertyIfComplex (target[p[0]], p[1])) {
                                target[p[0]] = p[1]
                            }
                        } else if (addNewProperty) {
                            target[p[0]] = p[1]
                        }
                    })
                }

                function getId(obj) {
                    if (_.isFunction(obj.getId)) return obj.getId();
                    if (!_.isUndefined(obj._$id$)) return ko.unwrap(obj._$id$);
                    if (!_.isUndefined(obj.id)) return ko.unwrap(obj.id)
                }

                function removeById(arr, id) {
                    for (let i = arr.length - 1; i >=0; i--) {
                        if (getId(arr[i]) === id) arr.splice(i, 1)
                    }
                }

                function findById(arr, id) {
                    return _.find(arr, function(el) {
                        return getId(el) === id
                    })
                }

                function updateArray(target, source) {
                    if (source.length === 0) return;
                    target = ko.unwrap(target);
                    if (!_.isArray(target)) return;
                    let id, targetEl;
                    if (_.isObject(source[0])) {
                        if (source[0]._$clear$) {
                            if (target.removeAll) target.removeAll();
                            else target = []
                        } else {
                            _.each(source, function(sourceEl) {
                                if (_.isObject(sourceEl)) {
                                    if (sourceEl._$add$) {
                                        delete sourceEl["_$add$"];
                                        target.push(ko.viewmodel.fromModel(sourceEl))
                                    } else if (sourceEl._$remove$){
                                        id = getId(sourceEl);
                                        targetEl = removeById(target, id)
                                    } else {
                                        id = getId(sourceEl);
                                        targetEl = findById(target, id);
                                        if (!_.isUndefined(targetEl)) {
                                            updateObject(targetEl, sourceEl)
                                        }
                                    }
                                }
                            })
                        }
                    } else {
                        const len = Math.min(target.length, source.length);
                        for (let i = 0; i < len; i++) {
                            if (ko.isObservable(target[i])) {
                                target[i](source[i])
                            } else {
                                target[i] = source[i]
                            }
                        }
                        if (source.length < target.length) {
                            target = target.splice(0, source.length)
                        }
                    }
                }

                if (_.isObject(viewModel)) {
                    if (vm.__form__ === "ko.viewmodel" && viewModel.__form__ === "ko.viewmodel") {
                        delete viewModel.__form__;
                        ko.viewModel.updateFromModel(vm, viewModel)
                    } else {
                        updateObject(vm, viewModel)
                    }
                } else if (_.isArray(viewModel)) {
                    updateArray(vm, viewModel)
                }
            }
        });

    })();

    win.vue = app.vm;
})(window, ko, jQuery);

/***** The Global vm *****/
(function($){
    app.registerConstructor("Global", function() {
        this.isSpringboard = false;
        this.viewPort = {
            height: ko.observable(0),
            width: ko.observable(0),
            docWidth: ko.observable(0),
            docHeight: ko.observable(0)
        };
        this.parentScrollTop = function() {
            if (window !== window.parent) {
                $(window.parent.document).find('html, body').animate({scrollTop: 0});
            }
        };
        this.getScrollViewportPosition = function () {
            const $win = $(window);
            const viewport = {
                top: $win.scrollTop(),
                left: $win.scrollLeft()
            };
            viewport.bottom = viewport.top + $win.height();
            viewport.right = viewport.left + $win.width();
            return viewport;
        };
        this.showClientMessage = function() {
            app.console.error("showClientMessage is not implemented.")
        };
        this.showLoadingBox = _.noop;  //to be implemented by sub systems
        this.hideLoadingBox = _.noop;  //to be implemented by sub systems
        this.__resize__ = function() {
            const self = this;
            self.viewPort.width($(window).width( ));
            self.viewPort.height($(window).height());
            self.viewPort.docWidth($(document).width());
            self.viewPort.docHeight($(document).height());
            const viewPort = {
                height: self.viewPort.height(),
                width: self.viewPort.width(),
                docWidth: self.viewPort.docWidth(),
                docHeight: self.viewPort.docHeight()
            };
            for (let vmName in app.vm) {
                if (app.vm.hasOwnProperty(vmName)) {
                    if (vmName !== 'Global' && app.vm[vmName].__resize__) {
                        app.vm[vmName].__resize__(viewPort)
                    }
                }
            }
        };
        this.$$resizeTimeout = 0;

        this.runWhen = function(action, checker, retry, delay, interval) {
            let t = null;
            if (typeof interval === "undefined") interval = 250;
            function run() {
                if (checker()) {
                    action();
                } else {
                    if ((retry--) > 0) {
                        t = setTimeout(run, interval)
                    } else {
                        if (t) clearTimeout(t);
                    }
                }
            }
            if (delay === 0) delay = undefined;
            if (delay) {
                setTimeout(run, delay);
            } else {
                run();
            }
        };

        this.runUntil = function(action, checker, retry, delay, interval) {
            let t = null;
            if (typeof interval === "undefined") interval = 250;
            function run() {
                action();
                if (!checker()) {
                    if ((retry--) > 0) {
                        t = setTimeout(run, interval)
                    } else {
                        if (t) clearTimeout(t);
                    }
                }
            }
            if (delay === 0) delay = undefined;
            if (delay) {
                setTimeout(run, delay);
            } else {
                run();
            }
        };

        this.runTick = function(action, interval, immediate) {
            let t = null;
            if (typeof interval === "undefined") interval = 5000;
            if (typeof immediate === "undefined") immediate = true;
            const stopTick = function() {
                if (t != null) {
                    clearTimeout(t);
                }
            };
            const nextTick = function() {
            	stopTick();
                t = setTimeout(function() {action(nextTick)}, interval)
            };
            if (immediate) {
                action(nextTick);
            } else {
                nextTick();
            }
            return stopTick;
        };

        /*--- Fix View State --- */
        /* Copied from OmniFaces.FixViewState but also handles encodeURL for portlet environment */
        this.FixViewState = (function(window, document) {

            // "Constant" fields ----------------------------------------------------------------------------------------------

            const VIEW_STATE_PARAM = "javax.faces.ViewState";
            const ENCODED_URL_PARAM = "javax.faces.encodedURL";
            const VIEW_STATE_REGEX = new RegExp("^([\\w]+:)?" + VIEW_STATE_PARAM.replace(/\./g, "\\.") + "(:[0-9]+)?$");
            const RASP_CID_PARAM = new RegExp("(c_id|c_new)=[^&]*&?", "g");

            // Private static fields ------------------------------------------------------------------------------------------

            const self = {};

            // Public static functions ----------------------------------------------------------------------------------------

            function removeRaspConversationParameter(encodedURL) {
                const questionMarkPos = encodedURL.indexOf("?");
                if (questionMarkPos < 0) return encodedURL;
                const base = encodedURL.substring(0, questionMarkPos);
                const queryString = encodedURL.substring(questionMarkPos + 1).replace(RASP_CID_PARAM, "").replace(/&+$/, "");
                if (queryString.length > 0) {
                    return base + "?" + queryString;
                } else {
                    return base;
                }
            }

            /**
             * Apply the "fix view state" on the current document based on the given XML response.
             * @param {XMLHttpRequest} xhr The XMLHttpRequest in the ajax callback
             */
            self.apply = function(xhr) {
                if (typeof xhr === "undefined") return;
                const responseXML = xhr.responseXML;
                const encodedURL = xhr.pfSettings && xhr.pfSettings.url;
                if (typeof responseXML === "undefined" || typeof encodedURL === "undefined") {
                    return;
                }

                const viewStateValue = getViewStateValue(responseXML);

                if (!viewStateValue) {
                    return;
                }

                const encodedURLWithoutRaspCid = removeRaspConversationParameter(encodedURL);

                for (let i = 0; i < document.forms.length; i++) {
                    const form = document.forms[i];
                    const viewStateElement = form[VIEW_STATE_PARAM];
                    const encodedURLElement = form[ENCODED_URL_PARAM];

                    if (form.method === "post" && encodedURLElement && encodedURLElement.value === encodedURL && !viewStateElement) {
                        // This POST form doesn't have a view state. This isn't right. Create it.
                        createViewStateElement(form, viewStateValue);
                    }

                    if (form.method === "post" && encodedURLElement && !viewStateElement) {
                        if (removeRaspConversationParameter(encodedURLElement.value) === encodedURLWithoutRaspCid) {
                            // This POST form doesn't have a view state. This isn't right. Create it.
                            createViewStateElement(form, viewStateValue);
                        }
                    }
                }
            };

            // Private static functions ---------------------------------------------------------------------------------------

            /**
             * Returns the view state value from the given XML response.
             * @param {Document} responseXML The XML response of the XMLHttpRequest.
             * @return {string} The view state value from the given XML response.
             */
            function getViewStateValue(responseXML) {
                const updates = responseXML.getElementsByTagName("update");

                for (let i = 0; i < updates.length; i++) {
                    const update = updates[i];

                    if (VIEW_STATE_REGEX.exec(update.getAttribute("id"))) {
                        return update.textContent || update.innerText;
                    }
                }

                return null;
            }

            /**
             * Create view state hidden input element with given view state value and add it to given form.
             * @param {HTMLFormElement} form The form to add the view state hidden input element to.
             * @param {string} viewStateValue The view state value to be added to the newly created view state hidden input element.
             */
            function createViewStateElement(form, viewStateValue) {
                let hidden;

                try {
                    hidden = document.createElement("<input name='" + VIEW_STATE_PARAM + "'>"); // IE6-8.
                }
                catch(e) {
                    hidden = document.createElement("input");
                    hidden.setAttribute("name", VIEW_STATE_PARAM);
                }

                hidden.setAttribute("type", "hidden");
                hidden.setAttribute("value", viewStateValue);
                hidden.setAttribute("autocomplete", "off");
                form.appendChild(hidden);
            }
            return self;

        })(window, document);

        /**
         * Check whether the current browser supports a given css property.
         *
         * Example:
         * app.vm.Global.browserSupportsCSSProperty('animation')
         *
         * returns true in modern browsers and false in IE9 or below.
         * @param propertyName
         * @returns {boolean}
         */
        this.browserSupportsCSSProperty = function(propertyName) {
            const elm = document.createElement('div');
            propertyName = propertyName.toLowerCase();

            if (elm.style[propertyName] !== undefined)
                return true;

            const propertyNameCapital = propertyName.charAt(0).toUpperCase() + propertyName.substr(1),
                domPrefixes = 'Webkit Moz ms O'.split(' ');

            for (let i = 0; i < domPrefixes.length; i++) {
                if (elm.style[domPrefixes[i] + propertyNameCapital] !== undefined)
                    return true;
            }
            return false;
        }
    }, true);
})(jQuery);

app.createVM("Global");

(function($) {
    $(document).ready(function() {
        $(window).on('resize', function() {
            if (app.vm.Global.$$resizeTimeout) {
                clearTimeout(app.vm.Global.$$resizeTimeout)
            }
            app.vm.Global.$$resizeTimeout = setTimeout(function() {app.vm.Global.__resize__()}, 200)
        });

        app.vm.Global.__resize__();
    })
})(jQuery);


/***** Custom bindings *****/

(function($){
    ko.bindingHandlers.slideVisible = {
        init: function(element, valueAccessor) {
            const value = ko.unwrap(valueAccessor());
            if (!value) $(element).hide()
        },
        update: function(element, valueAccessor, allBindings) {
            const value = ko.unwrap(valueAccessor());
            const duration = allBindings.get('duration') || 400;
            if (value)
                $(element).slideDown(duration);
            else
                $(element).slideUp(duration);
        }
    };
})(jQuery)

;(function($){
    ko.bindingHandlers.fadeVisible = {
        init: function(element, valueAccessor) {
            const value = ko.unwrap(valueAccessor());
            if (!value) $(element).hide()
        },
        update: function(element, valueAccessor, allBindings) {
            const value = ko.unwrap(valueAccessor());
            const duration = allBindings.get('duration') || 400;
            if (value)
                $(element).fadeIn(duration);
            else
                $(element).fadeOut(duration);
        }
    };
})(jQuery)

;(function($) {
    ko.bindingHandlers.hover = {
        init: function(element, valueAccessor) {
            const className = ko.unwrap(valueAccessor());
            $(element).hover(
                function() {$(this).addClass(className)},
                function() {$(this).removeClass(className)}
            )
        }
    };
})(jQuery);


ko.bindingHandlers.href = {
    update: function (element, valueAccessor) {
        ko.bindingHandlers.attr.update(element, function () {
            return { href: valueAccessor()}
        });
    }
};

ko.bindingHandlers.src = {
    update: function (element, valueAccessor) {
        ko.bindingHandlers.attr.update(element, function () {
            return { src: valueAccessor()}
        });
    }
};

ko.bindingHandlers.disabled = {
    update: function (element, valueAccessor) {
        let value = ko.unwrap(valueAccessor());
        if (value) {
            $(element).addClass('disabled')
        } else {
            $(element).removeClass('disabled')
        }
        ko.bindingHandlers.attr.update(element, function () {
            return { disabled: value}
        });
    }
};
ko.bindingHandlers.enabled = {
    update: function (element, valueAccessor) {
        const value = ko.unwrap(valueAccessor());
        if (value) {
            $(element).removeClass('disabled')
        } else {
            $(element).addClass('disabled')
        }
        ko.bindingHandlers.attr.update(element, function () {
            return { disabled: !value}
        });
    }
};

ko.bindingHandlers.hidden = {
    update: function (element, valueAccessor) {
        const value = ko.unwrap(valueAccessor());
        ko.bindingHandlers.visible.update(element, function () { return !value; });
    }
};

ko.bindingHandlers.toggle = {
    init: function (element, valueAccessor) {
        const value = valueAccessor();
        ko.applyBindingsToNode(element, {
            click: function () {
                value(!value());
            }
        });
    }
};

(function() {
    const factory = function(n) {
        return {
            init: function(element, valueAccessor) {
                const classNames = ko.unwrap(valueAccessor());
                const el=$(element);
                el.addClass(classNames).data("prev-class-" + n, classNames)
            },
            update: function(element, valueAccessor) {
                const el = $(element);
                const prev = el.data("prev-class-" + n);
                const current = " " + ko.unwrap(valueAccessor()) + " ";
                const toRemove = ko.utils.arrayFilter((prev || "").split(/\s+/), function(item) {
                    return app.utils.trimString(item).length > 0 && current.indexOf(" " + item + " ") < 0
                }).join(" ");
                if (toRemove.length > 0) el.removeClass(toRemove);
                el.addClass(current)
            }
        };
    };

    ko.bindingHandlers.styleClass = factory(0);
    for (let i = 1; i < 10; i++) {
        ko.bindingHandlers['styleClass' + i] = factory(i)
    }
})(jQuery);

ko.bindingHandlers.stop = {
    init: function() {
        return { controlsDescendantBindings: true };
    }
};

ko.virtualElements.allowedBindings.stop = true;

ko.bindingHandlers.noKnockout = {
    init: function() {
        return { controlsDescendantBindings: true };
    }
};

ko.virtualElements.allowedBindings.noKnockout = true

;(function($){
    ko.bindingHandlers.bindChildren = {
        init: function(element) {
            $.each(element.attributes, function() {
                try {
                    let attr = this, name, value, parts;
                    if (attr.specified) {
                        name = attr.name;
                        if (name.match(/^data-bind-child(?:-\d+)?$/i)) {
                            value = attr.value;
                            parts = value.split(/\s*@\s*/);
                            if (parts.length === 2) {
                                $(element).find(parts[1]).each(function() {
                                    $(this).attr("data-bind", parts[0])
                                })
                            } else {
                                app.console.error("Invalid data-bind-child content: " + value)
                            }
                        }
                    }
                } catch (err) {
                    app.console.error(err)
                }
            })
        }
    }
})(jQuery);

ko.virtualElements.allowedBindings.bindChildren = true

;(function($) {
    ko.bindingHandlers.select2 = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            if (element.tagName.toLowerCase() !== "select") {
                app.console.error("select2 binging must apply on a <select> element.");
                app.console.log(element);
                return;
            }
            if (!$ || !$.fn || !$.fn.select2) {
                app.console.error("jQuery with select2 plugin is required.");
                app.console.log(element);
                return;
            }

            // bind descendant elements
            ko.applyBindingsToDescendants(bindingContext, element);
            // apply select2 plugin
            const opts = ko.unwrap(valueAccessor());
            if (typeof opts !== "object") {
                $(element).select2()
            } else {
                $(element).select2(opts)
            }
            // Also tell KO *not* to bind the descendants itself, otherwise they will be bound twice
            return { controlsDescendantBindings: true };
        },

        update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            const selected = ko.unwrap(allBindings.get("selectedOptions"));
            $(element).select2("val", selected)
        }
    }
})(jQuery);

(function($) {
    ko.bindingHandlers.expandableTextField = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            if (ko.utils.tagNameLower(element) !== "input") {
                app.console.error("expandableTextfield binging must apply on a <input> element.");
                app.console.log(element);
                return;
            }
            if (!$ || !$.fn || !$.fn.expandableTextfield) {
                app.console.error("jQuery with expandableTextfield plugin is required.");
                app.console.log(element);
                return;
            }

            const opts = ko.unwrap(valueAccessor());
            if (_.isObject(opts)) {
                $(element).expandableTextfield()
            } else {
                $(element).expandableTextfield(opts)
            }
        }
    }
})(jQuery);

//Shortcut for common events

_.each(["dblclick", "onBlur", "onFocus", "onChange"], function(eventName) {
    ko.bindingHandlers[eventName] = {
        'init': function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            const newValueAccessor = function () {
                const result = {};
                result[eventName] = valueAccessor();
                return result;
            };
            return ko.bindingHandlers['event']['init'].call(this, element, newValueAccessor, allBindings, viewModel, bindingContext);
        }
    }
})

//Wrap the textInput and value handler to handle keepInitialValue binding 
;(function($) {
    const textInputHandler = ko.bindingHandlers.textInput;
    const valueHandler = ko.bindingHandlers.value;
    const initViewModel = function(element, valueAccessor, allBindings) {
        if (allBindings.has("keepInitialValue")) {
            if (ko.isWritableObservable(valueAccessor())) {
                valueAccessor()($(element).val())
            }
        }
    };

    ko.bindingHandlers.textInput = {
        'init': function (element, valueAccessor, allBindings) {
            initViewModel(element, valueAccessor, allBindings);
            textInputHandler.init(element, valueAccessor, allBindings)
        }
    };
    ko.bindingHandlers.textInput.__proto__ = textInputHandler;

    ko.bindingHandlers.value = {
        'init': function (element, valueAccessor, allBindings) {
            initViewModel(element, valueAccessor, allBindings);
            valueHandler.init(element, valueAccessor, allBindings)
        }
    };
    ko.bindingHandlers.value.__proto__ = valueHandler
})(jQuery);

//Wrap the checked handler to handle keepInitialValue binding 
(function() {
    const checkedHandler = ko.bindingHandlers.checked;
    const initViewModel = function(element, valueAccessor, allBindings) {
        function updateModel() {
            /* A simplified version of internal helper function in ko.bindingHandlers.checked */

            let isCheckbox = element.type === "checkbox",
                isRadio = element.type === "radio",
                isChecked = element.checked;
            const useCheckedValue = isRadio || isValueArray;
            const elemValue = useCheckedValue ? checkedValue() : isChecked;

            // We can ignore unchecked radio buttons, because some other radio
            // button will be getting checked, and that one can take care of updating state.
            if (isRadio && !isChecked) {
                return;
            }
            const isValueArray = isCheckbox && (ko.utils.unwrapObservable(valueAccessor()) instanceof Array);
            if (isValueArray) {
                app.console.error('"keepInitialValue" does not support array value on the "checked" binding.')
            } else {
                valueAccessor()(elemValue)
            }
        }

        if (allBindings.has("keepInitialValue")) {
            if (ko.isWritableObservable(valueAccessor())) {
                updateModel()
            }
        }
    };

    ko.bindingHandlers.checked = {
        'init': function (element, valueAccessor, allBindings) {
            initViewModel(element, valueAccessor, allBindings);
            checkedHandler.init(element, valueAccessor, allBindings)
        }
    };
    ko.bindingHandlers.checked.__proto__ = checkedHandler
})();

(function($) {
    let selectedOptionsHandler = ko.bindingHandlers.selectedOptions;
    ko.bindingHandlers.selectedOptions = {
        'init': function (element, valueAccessor, allBindings) {
            if (allBindings.has("keepInitialValue")) {
                (function () {
                    const value = valueAccessor(), valueToWrite = [];
                    ko.utils.arrayForEach(element.getElementsByTagName("option"), function(node) {
                        if (node.selected)
                            valueToWrite.push(ko.selectExtensions.readValue(node));
                    });
                    value(valueToWrite);
                })();
            }
            selectedOptionsHandler.init(element, valueAccessor, allBindings)
        },
        'update': function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            if (allBindings.has("select2")) {
                if (element.tagName.toLowerCase() !== "select") {
                    app.console.error("select2 binging must apply on a <select> element.");
                    app.console.log(element);
                    return;
                }
                if (!$ || !$.fn || !$.fn.select2) {
                    app.console.error("jQuery with select2 plugin is required.");
                    app.console.log(element);
                    return;
                }
                const selected = ko.unwrap(valueAccessor());
                $(element).select2("val", selected)
            }
            selectedOptionsHandler.update(element, valueAccessor, allBindings, viewModel, bindingContext)
        }

    };
    ko.bindingHandlers.selectedOptions.__proto__ = selectedOptionsHandler
})(jQuery);

ko.bindingHandlers.currency = {
    symbol: "$",
    decimal: 2,
    update: function(element, valueAccessor, allBindingsAccessor){
        return ko.bindingHandlers.text.update(element,function(){
            const value = +(ko.utils.unwrapObservable(valueAccessor()) || 0),
                symbol = ko.utils.unwrapObservable(allBindingsAccessor().symbol !== undefined
                    ? allBindingsAccessor().symbol
                    : ko.bindingHandlers.currency.symbol);
            decimal = ko.utils.unwrapObservable(allBindingsAccessor().decimal !== undefined
                ? allBindingsAccessor().decimal
                : ko.bindingHandlers.currency.decimal);
            return symbol + value.toFixed(decimal).replace(/(\d)(?=(\d{3})+(?:\.|$))/g, "$1,");
        });
    }
};

(function () {
    ko.bindingHandlers.inputmask =
    {
        init: function (element, valueAccessor, allBindingsAccessor) {

            const mask = valueAccessor();

            const observable = mask.value;

            if (ko.isObservable(observable)) {

                $(element).on('focusout change', function () {

                    if ($(element).inputmask('isComplete')) {
                        observable($(element).val());
                    } else {
                        observable(null);
                    }

                });
            }

            $(element).inputmask(mask);


        },
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            const mask = valueAccessor();

            const observable = mask.value;

            if (ko.isObservable(observable)) {

                const valuetoWrite = observable();

                $(element).val(valuetoWrite);
            }
        }

    };
})();

/** Knockout Extensions **/

ko.extenders.url = function(target, protocal) {
    if (!protocal) protocal = "http";
    const newComputedObservable = ko.pureComputed({
        read: target,
        write: function(newValue) {
            const current = target();
            let valueToWrite = newValue || "";
            if (app.utils.trimString(valueToWrite).length > 0 && current.indexOf("://") >= 0 && valueToWrite.indexOf("://") < 0) {
                valueToWrite = current.substring(current.indexOf("://") + 3)
            }
            if (valueToWrite.length > 10 && valueToWrite.indexOf("://") < 0 && valueToWrite[0] !== "/") {
                valueToWrite = protocal + "://" + valueToWrite;
            }
            if (valueToWrite !== current) {
                target(valueToWrite)
            } else {
                if (newValue !== current) {
                    target.notifySubscribers(valueToWrite);
                }
            }
        }
    }).extend({ notify: 'always'});

    //initialize with current value to make sure it is rounded appropriately
    newComputedObservable(target());

    //return the new computed observable
    return newComputedObservable;
};

/** Vue filters **/
if (window['Vue']) {
    Vue.filter('removeUnderScore', function(value, replacement) {
        return value.replace(/_/g, replacement || ' ');
    });

    Vue.filter('gt0', function(value) {
        return value > 0;
    });

    Vue.filter('gt1', function(value) {
        return value > 1;
    });

    Vue.filter('pluralizedLabel', function(value, label) {
        return app.utils.pluralize(label, value);
    });

    Vue.filter('attachPluralizedLabel', function(value, label) {
        return app.utils.pluralize(label, value, true);
    });
}
/** Vue filters ends **/


/* Patch PF to output better error message */
(function() {
    if (!window['PF']) return;
    if (window['originalPF']) return;
    window.originalPF = window.PF;
    window.PF = function() {
        const result = window.originalPF.apply(this, arguments);
        if (typeof result === 'undefined') {
            app.console.info('PF(%o) is undefined', arguments);
        }
        return result;
    }
})();

